import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/eligibleParticipants";

const getEligibleParticipants = (params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          luckyDrawUuid: params.luckyDrawUuid,
          search: params.search,
          orderBy: params.orderBy,
          limit: params.limit,
          skip: params.skip,
        },
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default getEligibleParticipants;
